import { Card, Grid, Stack, TextField, Typography, MenuItem } from '@mui/material';
import React, { useState } from 'react';
import ContentLoader from '../../components/ContentLoader';
import useAuth from '../../hooks/useAuth';
import { PieChart } from '@mui/icons-material';
import CardQuick from '../../components/Card';
import StyledChip from '../../components/StyledChip';
import NextAppointmentsCard from './NextAppointmentsCard';
import ValidationChart from './ValidationsChart';
import ActsStatsDoghnout from './ActsStatsDoghnout';
import EsquebraDoghnout from './EsquebraDoghnout';
import CurrentAccountCard from './CurrentAccountCard';
import MovementsChart from './MovementsChart';

const Dashboard = () => {
    const [isLoading, setIsLoading] = useState(false);
    const { user } = useAuth();
    const [userValue, setUserValue] = useState(0);
    return (
        <React.Fragment>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Stack direction={'row'} spacing={4}>
                        <Typography variant='h1' fontWeight={600}>Dashboard</Typography>
                        <TextField
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        borderRadius: 8,
                                    },
                                },
                            }}
                            select
                            size="small"
                            defaultValue=""
                            variant="outlined"
                            value={userValue}
                            onChange={(e) => {
                                setUserValue(e.target.value)
                                //Pesquisa Novamente
                            }}
                        >
                            <MenuItem value={0}>Todos os Locais</MenuItem>
                            {user.locations?.map((option) => (
                                <MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>
                            ))}
                        </TextField>
                    </Stack>
                </Grid>
                <Grid item xs={3} >
                    <ActsStatsDoghnout locationId={userValue} />
                </Grid>
                {/*                <Grid item xs={3} minWidth={'300px'} maxWidth={'300px'}>
                    <EsquebraDoghnout />
                </Grid> */}
                <Grid item xs={6} >
                    <ValidationChart locationId={userValue} />
                </Grid>
                <Grid item xs={3} >
                    <NextAppointmentsCard locationId={userValue} />

                </Grid>
                <Grid item xs={3} >
                    <CurrentAccountCard locationId={userValue} />
                </Grid>
                <Grid item xs={4}>
                    <MovementsChart locationId={userValue} />
                </Grid>
            </Grid>
            <ContentLoader open={isLoading} />
        </React.Fragment>


    )
}

export default Dashboard;

